import React from 'react';
import Box from '@material-ui/core/Box';
import IntlMessages from '../../../../../../@crema/utility/IntlMessages';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Avatar from '@material-ui/core/Avatar';
import DeleteIcon from '@material-ui/icons/Delete';
import {makeStyles} from '@material-ui/core/styles';
import {grey, red} from '@material-ui/core/colors';
import {Fonts} from '../../../../../../shared/constants/AppEnums';
import Hidden from '@material-ui/core/Hidden';
import {CheckedListObj} from '../../../../../../types/models/apps/ProjectBoard';
import {CremaTheme} from '../../../../../../types/AppContextPropsType';
import { Keys } from 'mp/core/craEngine/SubSystems/sceneManagement/SceneComponent';

const useStyles = makeStyles((theme: CremaTheme) => ({
  btnRoot: {
    // backgroundColor: red[500],
    // color: theme.palette.primary.contrastText,
    fontWeight: Fonts.LIGHT,
    textTransform: 'capitalize',
    paddingLeft: 16,
    paddingRight: 16,
    '&:hover, &:focus': {
      // backgroundColor: red[800],
      // color: theme.palette.primary.contrastText,
    },
  },
  checkboxRoot: {
    marginRight: 8,
  },
  textFieldRoot: {
    width: '100%',
    '& .inputprops-root': {
      width: '100%',
      margin: 'auto',
    },
  },
  avatarRoot: {
    backgroundColor: grey[500],
    color: theme.palette.primary.contrastText,
    cursor: 'pointer',
    '&:hover, &:focus': {
      backgroundColor: grey[800],
      color: theme.palette.primary.contrastText,
    },
  },
}));

interface CardAttachmentsProps {
  onAddNewCheckedItem: () => void;
  checkedList: CheckedListObj[];
  onSetCheckedItemText: (value: string, id: string) => void;
  onSetCheckedItemCheckbox: (value: boolean, id: string) => void;
  onDeleteCheckedItem: (id: string) => void;
}

const CardCheckedList: React.FC<CardAttachmentsProps> = ({
  onAddNewCheckedItem,
  checkedList,
  onSetCheckedItemText,
  onDeleteCheckedItem,
  onSetCheckedItemCheckbox,
}) => {
  const classes = useStyles();

  const keyPress=(e:any)=>{
    if (e.keyCode == Keys.RETURN
      // && e.shiftKey
    ) {
      onAddNewCheckedItem();
    }
  }

  return (
    <Box mb={8}>
      <Box mb={4} display='flex' alignItems='center'>
        <Box>
          <Box component='h4'>
            <IntlMessages id='projectboard.checkedLists' />
          </Box>
        </Box>
        <Box ml='auto' px='8'>
          <Button
            className={classes.btnRoot}
            color='secondary' 
            variant='outlined'
            onClick={() => onAddNewCheckedItem()}>
            <IntlMessages id='projectboard.addNew' />
          </Button>
        </Box>
      </Box>

      {checkedList.map(checkedItem => {
        return (
          <Box display='flex' alignItems='center' key={checkedItem.id}>
            <Box mb={4} flex={1} display='flex' alignItems='center'>
              <Hidden xsDown>
                {' '}
                <Checkbox
                  className={classes.checkboxRoot}
                  checked={checkedItem.checked}
                  onChange={e =>
                    onSetCheckedItemCheckbox(e.target.checked, checkedItem.id)
                  }
                />
              </Hidden>
              <TextField
                autoFocus 
                className={classes.textFieldRoot}
                variant='outlined'
                InputProps={{
                  className: 'inputprops-root',
                }}
                value={checkedItem.title}
                onChange={e =>
                  onSetCheckedItemText(e.target.value, checkedItem.id)
                }
                onKeyDown={keyPress}
              />
            </Box>
            <Box component='span' mb={4} ml={3}>
              <Avatar
                className={classes.avatarRoot}
                onClick={() => onDeleteCheckedItem(checkedItem.id)}>
                <DeleteIcon />
              </Avatar>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default CardCheckedList;
